module.exports = __webpack_public_path__ + "static/media/comprar.6d1ea1f7.png";